var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_14760",
    "data-name": "Group 14760",
    transform: "translate(-4811.5 -2594)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(4811.5 2594)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12293",
    "data-name": "Group 12293",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4499",
    "data-name": "Rectangle 4499",
    width: 35,
    height: 35,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_23",
    "data-name": "Union 23",
    d: "M-2575.55,1980.918a1.652,1.652,0,0,1-1.65-1.651v-6.027h-2.314v6.027a1.652,1.652,0,0,1-1.65,1.651h-6.79a1.653,1.653,0,0,1-1.65-1.651V1968.8h-1.14a2.239,2.239,0,0,1-2.1-1.44,2.239,2.239,0,0,1,.583-2.48l12.387-11.287a2.25,2.25,0,0,1,1.518-.59,2.25,2.25,0,0,1,1.518.59l12.387,11.287a2.24,2.24,0,0,1,.583,2.479,2.238,2.238,0,0,1-2.1,1.441h-1.14v10.47a1.653,1.653,0,0,1-1.651,1.651Zm3.076-25.776h5.577a.837.837,0,0,1,.831.844v5.082Z",
    transform: "translate(2595.856 -1948.77)",
    fill: "#da291c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11946",
    "data-name": "Group 11946",
    transform: "translate(22.519 6.047)",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11945",
    "data-name": "Group 11945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5535",
    "data-name": "Path 5535",
    d: "M349.742,42.73h-5.769l6.628,6.027V43.589A.859.859,0,0,0,349.742,42.73Z",
    transform: "translate(-343.973 -42.73)",
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeOn);
export default __webpack_public_path__ + "static/media/icon_home_on.2024f8076f806730ddcf7cb9f38e9835.svg";
export { ForwardRef as ReactComponent };